// Component: TwoUpText
// Author: Susmita
import * as React from 'react';
import TwoUpTextUI from '@component/TwoUpText';
import { Text, withSitecoreContext, RichText } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import EditableLink from '../../react/EditableLink';
import WBRString from '@component/WbrString';

const TwoUpText = (props) => {
  return (
    <>
      {
        <TwoUpTextUI
          titleleft={<Text field={props.fields?.HeaderLeft} />}
          textleft={<RichText field={props.fields?.DescriptionLeft} />}
          titleright={<Text field={props.fields?.HeaderRight} />}
          textright={<RichText field={props.fields?.DescriptionRight} />}
          linktypeleft={props.fields?.LinkTypeLeft?.fields?.Value?.value}
          linktyperight={props.fields?.LinkTypeRight?.fields?.Value?.value}
          linkleft={
            <RoutableLink field={props.fields?.LinkLeft} useATag={true}>
              <WBRString tag="span">
                <Text field={props.fields?.LinkTextLeft} />
              </WBRString>
            </RoutableLink>
          }
          linkright={
            <RoutableLink field={props.fields?.LinkRight} useATag={true}>
              <WBRString tag="span">
                <Text field={props.fields?.LinkTextRight} />
              </WBRString>
            </RoutableLink>
          }
        />
      }
    </>
  );
};

export default withSitecoreContext()(TwoUpText);
